import type { HmiSymbolDefinition } from "../schema/hmi-symbol.schema";

export const builtinHmiSymbols: HmiSymbolDefinition[] = [
  {
    id: "builtin.hvac.fan",
    version: 1,
    title: "Fan",
    category: "hvac",
    builtIn: true,
    viewport: { width: 180, height: 180 },
    layers: [
      { id: "outer", type: "circle", style: { stroke: "#285f4a", strokeWidth: 8, fill: "#f3f8f5" }, bindings: [] },
      { id: "blade_a", type: "line", style: { stroke: "#1f7a4a", strokeWidth: 10 }, bindings: [], ref: { x: 90, y: 90 } },
      { id: "blade_b", type: "line", style: { stroke: "#1f7a4a", strokeWidth: 10 }, bindings: [], ref: { x: 90, y: 90 } },
      { id: "hub", type: "circle", style: { fill: "#1f7a4a" }, bindings: [] },
    ],
    metadata: { description: "Rotating supply or exhaust fan." },
  },
  {
    id: "builtin.process.pump",
    version: 1,
    title: "Pump",
    category: "process",
    builtIn: true,
    viewport: { width: 200, height: 140 },
    layers: [
      { id: "body", type: "rect", style: { fill: "#f9fbfa", stroke: "#265944", strokeWidth: 4 }, bindings: [] },
      { id: "motor", type: "rect", style: { fill: "#dceae2", stroke: "#265944", strokeWidth: 4 }, bindings: [] },
      { id: "flow", type: "line", style: { stroke: "#1f7a4a", strokeWidth: 10 }, bindings: [] },
    ],
    metadata: { description: "Horizontal circulation pump." },
  },
  {
    id: "builtin.process.valve",
    version: 1,
    title: "Valve",
    category: "process",
    builtIn: true,
    viewport: { width: 160, height: 120 },
    layers: [
      { id: "line", type: "line", style: { stroke: "#2f5d4d", strokeWidth: 8 }, bindings: [] },
      { id: "body", type: "path", style: { fill: "#ffffff", stroke: "#2f5d4d", strokeWidth: 4 }, bindings: [] },
    ],
    metadata: { description: "Inline process valve." },
  },
  {
    id: "builtin.hvac.damper",
    version: 1,
    title: "Damper",
    category: "hvac",
    builtIn: true,
    viewport: { width: 180, height: 100 },
    layers: [
      { id: "duct", type: "rect", style: { fill: "#eef3f0", stroke: "#2f5d4d", strokeWidth: 4 }, bindings: [] },
      { id: "blade", type: "line", style: { stroke: "#1f7a4a", strokeWidth: 8 }, bindings: [] },
    ],
    metadata: { description: "HVAC duct damper." },
  },
  {
    id: "builtin.process.tank",
    version: 1,
    title: "Tank",
    category: "process",
    builtIn: true,
    viewport: { width: 180, height: 240 },
    layers: [
      { id: "shell", type: "rect", style: { fill: "#f9fbfa", stroke: "#2c5a49", strokeWidth: 4 }, bindings: [] },
      { id: "level", type: "rect", style: { fill: "#8fd3a7" }, bindings: ["level"] },
    ],
    metadata: { description: "Vertical storage tank." },
  },
  {
    id: "builtin.process.pipe",
    version: 1,
    title: "Pipe",
    category: "process",
    builtIn: true,
    viewport: { width: 220, height: 36 },
    layers: [
      { id: "pipe", type: "line", style: { stroke: "#4f7f6c", strokeWidth: 14 }, bindings: [] },
    ],
    metadata: { description: "Process pipe run." },
  },
  {
    id: "builtin.hvac.duct",
    version: 1,
    title: "Duct",
    category: "hvac",
    builtIn: true,
    viewport: { width: 220, height: 50 },
    layers: [
      { id: "duct", type: "rect", style: { fill: "#dae6df", stroke: "#49695b", strokeWidth: 4 }, bindings: [] },
    ],
    metadata: { description: "HVAC duct segment." },
  },
  {
    id: "builtin.status.lamp",
    version: 1,
    title: "Status Lamp",
    category: "generic",
    builtIn: true,
    viewport: { width: 100, height: 100 },
    layers: [
      { id: "lamp", type: "circle", style: { fill: "#c6d2cb", stroke: "#355b4a", strokeWidth: 4 }, bindings: ["status"] },
    ],
    metadata: { description: "Status indicator lamp." },
  },
];

export function getBuiltinSymbolById(definitionId: string): HmiSymbolDefinition | undefined {
  return builtinHmiSymbols.find((symbol) => symbol.id === definitionId);
}

